module.exports = __webpack_public_path__ + "static/media/macbook_mask.c5554dbb.png";